import { ReactElement } from 'react';
import Image from '@/components/LocalImage';
import styles from '@/styles/pages/home/banner-page.module.less';
import { Link } from 'react-router-dom';
const BannerPage = (): ReactElement => {
    const __children = [] as ReactElement[];
    const randomNumber = (max: number, min: number) => {
        const randomnum = Math.floor(Math.random() * (max - min + 1) + min);
        return randomnum;
    };
    const mywidth = document.documentElement.clientWidth; //获取当前可视宽度
    const myheight = document.documentElement.clientHeight; //获取当前可视高度
    for (let i = 0; i < 20; i++) {
        const top = randomNumber(-myheight * 0.2, -myheight * 0.5) + 'px';
        const left = randomNumber(mywidth * 0.7, -mywidth * 0.3) + 'px';
        __children.push(<div style={{ top: top, left: left, animationDelay: i % 6 == 0 ? '0s' : i * 0.8 + 's' }} className={styles['star']} key={i}></div>);
    }

    return (
        <div id="content" className={styles['content']}>
            {__children}
            {/* PC端 */}
            <div className={styles['content-data']}>
                <div className="div">
                    <Image className={styles['image']} name="title" dir="/images/home" type="svg"></Image>
                </div>
                <div className={styles['discover']}>
                    <Link to="/discover">
                        <div className="flex">
                            <p>Discover AI & Games Drag</p>
                            <Image className="ml-1" name="right-icon" type="svg" dir="/images/home"></Image>
                        </div>
                        <div className={styles['lable']}>to discover more</div>
                    </Link>
                </div>
                <div className={styles['bottom-text']}>DISCOVER MORE GAMES</div>
            </div>
            {/* 移动端 */}

            <div className={styles['mini-center']}>
                <Image className={styles['image']} name="mini-title" dir="/images/mobile" type="svg"></Image>
            </div>
        </div>
    );
};

export default BannerPage;
